// ======================================================================
// File Name       : PageUtils
//
// Copyright(C) 2017 NIPPON TELEGRAPH AND TELEPHONE EAST CORPORATION All
// Rights Reserved.
//
// This source code or any portion thereof must not be
// reproduced or used in any manner whatsoever.
// ======================================================================

import React from 'react';
import { matchPath } from 'react-router';
import createHistory from 'history/createBrowserHistory';
import * as ICON from '../constants/IconConstants';
import SUB_ROUTES from '../constants/SubRouteConstants';
import * as actionType from '../constants/actionTypes/page';
import EnvelopeImage from '../images/Mail.png';
import RegistImage from '../images/ic16-plus-circle.svg';
import RegistRoleImage from '../images/ic16-new-role.svg';
import QuestionActiveImage from '../images/ic20-align-justify-active.png';
import DrillImage from '../images/ic20-bookmark.png';
import DrillSkinImage from '../images/ic20-photos.svg';
import QuestionImage from '../images/ic20-align-justify.png';
import AppsImage from '../images/icon-multiLaguageBook_filled.svg';
import ChatImage from '../images/ic20-chat.png';
import ContentDocumentActiveImage from '../images/ic20-content-document-active.png';
import ContentDocumentImage from '../images/ic20-content-document.png';
import ContentDrillActiveImage from '../images/ic20-content-drill-active.png';
import ContentDrillImage from '../images/ic20-content-drill.png';
import ContentLinkActiveImage from '../images/ic20-content-link-active.png';
import ContentLinkImage from '../images/ic20-content-link.png';
import ContentVideoActiveImage from '../images/ic20-content-video-active.png';
import ContentVideoImage from '../images/ic20-content-video.png';
import EditImage from '../images/ic20-edit.png';
import MessageImage from '../images/ic20-email-alt.png';
import EmailImage from '../images/ic20-email.png';
import FlagImage from '../images/ic20-flag.png';
import HomeImage from '../images/ic20-home.png';
import KeyImage from '../images/ic20-key.png';
import LiveImage from '../images/ic20-mic.png';
import ImportImage from '../images/ic20-open-in-browser.svg';
import RecordImage from '../images/ic20-performance.png';
import ReceivedMessageActiveImage from '../images/ic20-received-message-active.png';
import ReceivedMessageImage from '../images/ic20-received-message.png';
import RotateImage from '../images/ic20-rotate.png';
import SentMessageActiveImage from '../images/ic20-sent-message-active.png';
import SentMessageImage from '../images/ic20-sent-message.png';
import SystemImage from '../images/ic20-settings.png';
import AuthorityImage from '../images/ic20-suitcase.png';
import ScoringImage from '../images/ic20-tag.png';
import LearningImage from '../images/ic20-trending-up.png';
import TvImage from '../images/ic20-tv.png';
import UserImage from '../images/ic20-user.png';
import GroupImage from '../images/ic20-users.png';
import ContentImage from '../images/ic20-video.png';
import NoticeImage from '../images/ic20-volume-max.png';
import SubMenu from '../images/submenu.png';
import Image from '../images/ic20-image.png';
import store from '../store';
import ApproveReport from '../images/ic20-approve-report.png';
import CompanyImage from '../images/ic20-company.png';
import LayerImage from '../images/ic20-layers.png';
import NotificationImage from '../images/ic20-notification.png';
import SyncImage from '../images/ic20-sync.png';
import ServiceImage from '../images/ic20-view-boxes.png';
import { GTM_CODE } from '../constants';
import PAGE_TITLE_CONFIG from '../constants/PageTitleConstants';
import { SUPER_USER_SECERN_ID } from '../constants/index';
import * as Path from '../constants/PathConstants';
import { EDIT_ACCOUNT_TYPE, EDIT_ACCOUNT_VALUE } from '../constants/LocalStorageConstants';
import { SUPERUSER_LOGIN_TYPE } from '../constants/CommonConstants';
import { isOEMUser } from './AuthedUtils';

export function checkSearchCondition(url, parentPath) {
  if (SUB_ROUTES[parentPath]) {
    if (url !== parentPath) {
      let match = null;
      const length = SUB_ROUTES[parentPath].length;
      for (let i = 0; i < length; i++) {
        const subRoute = SUB_ROUTES[parentPath][i];
        match = matchPath(url, {
          path: subRoute,
          exact: true,
          strict: false,
        });
        if (match) {
          break;
        }
      }
      if ((match && match.params.id === 'register') || (match && match.params.id === 'import')) {
        match = null;
      }
      if (!match) {
        store.dispatch({
          type: actionType.CLEAR_SEARCH_CONDITION,
        });
      }
    }
  }
}

export function checkSearchConditionSub(url, parentPath) {
  if (SUB_ROUTES[parentPath]) {
    if (url !== parentPath) {
      let match = null;    
      const length = SUB_ROUTES[parentPath].length;
      for (let i = 0; i < length; i++) {
        const subRoute = SUB_ROUTES[parentPath][i];
        match = matchPath(url, {
          path: subRoute,
          exact: true,
          strict: false,
        });
        if (match) {
          break;
        }
      }
      if ((match && match.params.id === 'register') || (match && match.params.id === 'import') || (match && match.params.id === 'top')) {
        match = null;
      }
      if (!match) {
        store.dispatch({
          type: actionType.CLEAR_SEARCH_CONDITION_SUB,
        });
      }
    }
  }
}


export function checkChildRoute(url, parentPath) {
  let match = null;
  if (url !== SUB_ROUTES[parentPath]) {
    const length = SUB_ROUTES[parentPath] ? SUB_ROUTES[parentPath].length : 0;
    for (let i = 0; i < length; i++) {
      const subRoute = SUB_ROUTES[parentPath][i];
      match = matchPath(url, {
        path: subRoute,
        exact: true,
        strict: false,
      });
      if (match) {
        break;
      }
    }
  }
  return match;
}

export function showLoading() {
  return dispatch => new Promise((resolve, reject) => {
    dispatch({
      type: actionType.SHOW_LOADING,
    });
    resolve();
    return {};
  });
}

export function hideLoading() {
  return (dispatch) => {
    dispatch({
      type: actionType.HIDE_LOADING,
    });
  };
}

export function getIcon(icon) {
  let iconNav;
  switch (icon) {
    case ICON.TOP:
      iconNav = (<img src={HomeImage} alt="home" />);
      break;
    case ICON.SYSTEM:
      iconNav = (<img src={SystemImage} alt="system" />);
      break;
    case ICON.USER:
      iconNav = (<img src={UserImage} alt="user" />);
      break;
    case ICON.FLAG:
      iconNav = (<img src={FlagImage} alt="flag" />);
      break;
    case ICON.CHAT:
      iconNav = (<img src={ChatImage} alt="chat" />);
      break;
    case ICON.GROUP:
      iconNav = (<img src={GroupImage} alt="group" />);
      break;
    case ICON.CONTENT:
      iconNav = (
        <>
          <img className="sub-menu" src={SubMenu} alt="submenu" />
          <img src={ContentImage} alt="content" />
        </>
      );
      break;
    case ICON.DRILL:
      iconNav = (
        <>
          <img className="sub-menu" src={SubMenu} alt="submenu" />
          <img src={DrillImage} alt="drill" />
        </>
      );
      break;
    case ICON.DRILL_SKIN:
      iconNav = (<img src={DrillSkinImage} alt="drill skin" />);
      break;
    case ICON.TAB_QUESTION:
      iconNav = (<img src={QuestionImage} alt="question" />);
      break;
    case ICON.TAB_QUESTION_ACTIVE:
      iconNav = (<img src={QuestionActiveImage} alt="question active" />);
      break;
    case ICON.TAB_DRILL:
      iconNav = (<img src={ContentDrillImage} alt="drill" />);
      break;
    case ICON.TAB_DRILL_ACTIVE:
      iconNav = (<img src={ContentDrillActiveImage} alt="drill active" />);
      break;
    case ICON.TAB_VIDEO:
      iconNav = (<img src={ContentVideoImage} alt="video" />);
      break;
    case ICON.TAB_VIDEO_ACTIVE:
      iconNav = (<img src={ContentVideoActiveImage} alt="video active" />);
      break;
    case ICON.TAB_LINK:
      iconNav = (<img src={ContentLinkImage} alt="link" />);
      break;
    case ICON.TAB_LINK_ACTIVE:
      iconNav = (<img src={ContentLinkActiveImage} alt="link active" />);
      break;
    case ICON.TAB_DOCUMENT:
      iconNav = (<img src={ContentDocumentImage} alt="document" />);
      break;
    case ICON.TAB_DOCUMENT_ACTIVE:
      iconNav = (<img src={ContentDocumentActiveImage} alt="document active" />);
      break;
    case ICON.TAB_SENT_MESSAGE:
      iconNav = (<img src={SentMessageImage} alt="send message" />);
      break;
    case ICON.TAB_SENT_MESSAGE_ACTIVE:
      iconNav = (<img src={SentMessageActiveImage} alt="send message" />);
      break;
    case ICON.TAB_RECEIVED_MESSAGE:
      iconNav = (<img src={ReceivedMessageImage} alt="received message" />);
      break;
    case ICON.TAB_RECEIVED_MESSAGE_ACTIVE:
      iconNav = (<img src={ReceivedMessageActiveImage} alt="received message active" />);
      break;
    case ICON.TAB_LEARNING_HISTORY_COURSE:
      iconNav = (<img src={QuestionImage} alt="learning history course" />);
      break;
    case ICON.TAB_LEARNING_HISTORY_COURSE_ACTIVE:
      iconNav = (<img src={QuestionActiveImage} alt="learning history course acive" />);
      break;
    case ICON.TAB_LEARNING_HISTORY_USER:
      iconNav = (<img src={ContentDrillImage} alt="learning history user" />);
      break;
    case ICON.TAB_LEARNING_HISTORY_USER_ACTIVE:
      iconNav = (<img src={ContentDrillActiveImage} alt="learning history user active" />);
      break;
    case ICON.TAB_LEARNING_HISTORY_CONTENT:
      iconNav = (<img src={ContentDrillImage} alt="learning history content" />);
      break;
    case ICON.TAB_LEARNING_HISTORY_CONTENT_ACTIVE:
      iconNav = (<img src={ContentDrillActiveImage} alt="learning history content active" />);
      break;
    case ICON.TAB_SEND_EMAIL:
      iconNav = (<img src={ReceivedMessageImage} alt="send email" />);
      break;
    case ICON.TAB_SEND_EMAIL_ACTIVE:
      iconNav = (<img src={ReceivedMessageActiveImage} alt="send email active" />);
      break;
    case ICON.TAB_RESERVATION_EMAIL:
      iconNav = (<img src={ContentDocumentImage} alt="reservation email" />);
      break;
    case ICON.TAB_RESERVATION_EMAIL_ACTIVE:
      iconNav = (<img src={ContentDocumentActiveImage} alt="reservation email" />);
      break;
    case ICON.MESSAGE:
      iconNav = (<img src={MessageImage} alt="message" />);
      break;
    case ICON.EMAIL:
      iconNav = (<img src={EmailImage} alt="email" />);
      break;
    case ICON.LIVE:
      iconNav = (<img src={LiveImage} alt="live" />);
      break;
    case ICON.SCORING:
      iconNav = (<img src={ScoringImage} alt="scoring" />);
      break;
    case ICON.NOTICE:
      iconNav = (<img src={NoticeImage} alt="notice" />);
      break;
    case ICON.SERVICE_RECORD:
      iconNav = (<img src={RecordImage} alt="service record" />);
      break;
    case ICON.TV:
      iconNav = (<img src={TvImage} alt="tv" />);
      break;
    case ICON.LEARNING:
      iconNav = (<img src={LearningImage} alt="learning" />);
      break;
    case ICON.KEY:
      iconNav = (<img src={KeyImage} alt="key" />);
      break;
    case ICON.SUB_MENU:
      iconNav = (<img src={SubMenu} alt="submenu" />);
      break;
    case ICON.AUTHORITY:
      iconNav = (<img src={AuthorityImage} alt="authority" />);
      break;
    case ICON.REGIST:
      iconNav = (<img src={RegistImage} alt="regist" />);
      break;
    case ICON.REGIST_NEW_ROLE:
      iconNav = (<img src={RegistRoleImage} alt="registnewrole" />);
      break;
    case ICON.EDIT:
      iconNav = (<img src={EditImage} alt="edit" />);
      break;
    case ICON.IMPORT:
      iconNav = (<img src={ImportImage} alt="import" />);
      break;
    case ICON.APPS:
      iconNav = (<img src={AppsImage} alt="app" />);
      break;
    case ICON.ROTATE:
      iconNav = (<img src={RotateImage} alt="rotate" />);
      break;
    case ICON.ENVELOPE:
      iconNav = (<img src={EnvelopeImage} alt="envelope" />);
      break;
    case ICON.IMAGE:
      iconNav = (<img src={Image} alt="image" />);
      break;
    case ICON.APPROVEREPORT:
      iconNav = (<img src={ApproveReport} alt="approve report" />);
      break;
    case ICON.COMPANY:
      iconNav = (<img src={CompanyImage} alt="company image" />);
      break;
    case ICON.LAYER:
      iconNav = (<img src={LayerImage} alt="layer image" />);
      break;
    case ICON.NOTIFICATION:
      iconNav = (<img src={NotificationImage} alt="notification image" />);
      break;
    case ICON.SYNC:
      iconNav = (<img src={SyncImage} alt="sync image" />);
      break;
    case ICON.SERVICE:
      iconNav = (<img src={ServiceImage} alt="service image" />);
      break;
    case ICON.NONE_ICON:
      iconNav = (<img src="#" alt="" />);
      break;
    default:
      iconNav = (<i className={icon} />);
  }
  return iconNav;
}

export function setGTMConfig() {
  // insert GTM script
  const targetSrc = `https://www.googletagmanager.com/gtm.js?id=${GTM_CODE}`;
  if(!isContainScript(targetSrc)){ // check exist
    let script = document.createElement('script');
    const scriptText = document.createTextNode(`
    (function (w, d, s, l, i) {
      w[l] = w[l] || []; w[l].push({
          'gtm.start':
              new Date().getTime(), event: 'gtm.js'
      }); var f = d.getElementsByTagName(s)[0],
          j = d.createElement(s), dl = l != 'dataLayer' ? '&l=' + l : ''; j.async = true; j.src =
              'https://www.googletagmanager.com/gtm.js?id=' + i + dl; f.parentNode.insertBefore(j, f);
      })(window, document, 'script', 'dataLayer', '${GTM_CODE}');`);

    script.appendChild(scriptText);
     document.head.appendChild(script);
     
     script = document.createElement('noscript');
     const noScriptText = document.createTextNode(`
     <iframe src="https://www.googletagmanager.com/ns.html?id=${GTM_CODE}" height="0" width="0" style="display:none;visibility:hidden"></iframe>`);
     
     script.appendChild(noScriptText);
     if (!document.getElementsByTagName("noscript")[1]) { // noscript GTM
      document.body.appendChild(script);
    }
  }
}

// Step8.0.3 START
export function handleChangePageTitle() {
  var path = window.location.pathname;
  var normalizePath = PAGE_TITLE_CONFIG[path];

  if (!normalizePath) {
    const pathPart = path.split("/");

    if (path.includes("/edit")) {
      path = path.replace(pathPart[pathPart.length - 2], ":id");
    } else {
      if (
        path.includes("/messageThread/received/chat/") ||
        path.includes("/messageThread/sent/chat/")
      ) {
        path = path
          .replace(pathPart[pathPart.length - 1], ":userSecernId")
          .replace(pathPart[pathPart.length - 2], ":messageRootId");
      } else {
        path = path.replace(pathPart[pathPart.length - 1], ":id");
      }
    }
  }

  const pageTitle = normalizePath || PAGE_TITLE_CONFIG[path];
  pageTitle && (document.title = pageTitle);
}
// Step8.0.3 END

// Step10.0.0 START
export function checkAuthorSuperuser(authorSecernId, isSuperuser, representationUserSecernId) {
  const isAuthorSuperuser = authorSecernId && (isSuperuser
    && (authorSecernId.toLowerCase() === SUPER_USER_SECERN_ID
      || authorSecernId === representationUserSecernId));
  return isAuthorSuperuser;
}

export function isContainScript(targetSrc) {
  return Array.from(document.getElementsByTagName('script')).some((script) => script.src === targetSrc);
}
// Step10.0.0 END

// Step11.0.0 START
// Step12.0.0 TAS-18955 START
export function isEnterpriseFunctions(url) {
  const enterpriseFunction = [
    Path.ENTERPRISE,
    Path.ENTERPRISE_NOTIFICATION,
    Path.SERVICE_RECORD,
    Path.SUPERUSER_ENTERPRISE_ROLE,
    Path.SUPERUSER_SERVICE_ROLE,
    Path.SERVICE_GROUP,
    Path.ACCOUNT_EDIT,
    Path.SERVICE_MENU_NONE,
  ];
  return enterpriseFunction.some((item) => url.includes(item));
}
// Step12.0.0 TAS-18955 END

export function checkIsShowTabMenu(url, serviceNumber) {
  if (url.includes(Path.SERVICE_RECORD) && serviceNumber <= 1) return false;
  return true;
}

export const isIntegrationUserLoggedIn = localStorage.getItem(EDIT_ACCOUNT_TYPE) === EDIT_ACCOUNT_VALUE.INTEGRATION;
// Step11.0.0 END
// Step12.0.0 TAS-18955 START
export function checkShowLogo(camelizeJson) {
  const history = createHistory();
  if (camelizeJson.userInfo.superuserType === null) {
    return !isOEMUser(camelizeJson.contractEnterpriseHiddenStatus);
  }
  return (
    (camelizeJson.userInfo &&
      camelizeJson.userInfo.superuserType === SUPERUSER_LOGIN_TYPE.INTEGRATION_ROOT_SUPERUSER) ||
    isIntegrationUserLoggedIn ||
    !(
      camelizeJson.hiddenStatusSetting === 2 ||
      isOEMUser(camelizeJson.contractEnterpriseHiddenStatusInEnterprise) ||
      (!isEnterpriseFunctions(history.location.pathname) && isOEMUser(camelizeJson.contractEnterpriseHiddenStatus))
    )
  );
}
// Step12.0.0 TAS-18955 END
